import { t } from "@lingui/macro";
import { I18n } from "@lingui/react";
import {
  Button,
  ControlGroup,
  SupportingText,
  spacing,
  palette,
} from "@conserveit/blocks";
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const $Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 55px;
  padding: ${spacing.snug};
  background-color: ${palette.neutral2};
`;

const StyledSupportingText = styled(SupportingText)`
  margin-right: ${spacing.snug};
`;

const MenuFooter = ({
  onCancel,
  onConfirm,
  isConfirmDisabled,
  isZeroSites,
}) => (
  <I18n>
    {({ i18n }) => (
      <$Container>
        {isZeroSites && (
          <StyledSupportingText>
            {i18n._(
              t(
                "site_menu.select_site_prompt"
              )`At least one site must be selected`
            )}
          </StyledSupportingText>
        )}
        <ControlGroup tight>
          <Button thin appearance="plain" onClick={onCancel}>
            {i18n._(t("site_menu.cancel")`Cancel`)}
          </Button>
          <Button primary thin disabled={isConfirmDisabled} onClick={onConfirm}>
            {i18n._(t("site_menu.update")`Update`)}
          </Button>
        </ControlGroup>
      </$Container>
    )}
  </I18n>
);

MenuFooter.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isConfirmDisabled: PropTypes.bool.isRequired,
  isZeroSites: PropTypes.bool.isRequired,
};

export default MenuFooter;
